export default "__VITE_ASSET__e788de3f__"